import { useMutation } from "react-query";
import { ILoginData } from "types/Login";
import { postRegisterUser } from "../requests/RegisterUser";

export function useMutationRegisterUser() {
    const query = useMutation(postRegisterUser, {
        onSuccess: (data) => {
            if(data?.success) {
                let loginInfo: ILoginData = data?.data;
                // localStorage.setItem('idGuest', JSON.stringify(loginInfo.id))
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
